module.exports = __webpack_public_path__ + "static/media/support.623f7000.svg";